/**
 * aswbe search eapi（ShoppingShopping）
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CaptchaAuthenticationRequestKaptcha } from './captchaAuthenticationRequestKaptcha';
import { CaptchaAuthenticationRequestReCAPTCHA } from './captchaAuthenticationRequestReCAPTCHA';

/**
 * キャプチャ認証リクエストデータタイプ
 */
export interface CaptchaAuthenticationRequest {
  /**
   * 認証タイプ
   */
  authenticationType: CaptchaAuthenticationRequest.AuthenticationTypeEnum;
  reCAPTCHA?: CaptchaAuthenticationRequestReCAPTCHA;
  kaptcha?: CaptchaAuthenticationRequestKaptcha;
  /**
   * 出発地   照会用空港コード、都市コードの3レター   但し、空港コードの場合には、後ろに「+」を付けること   （例）   上海（空港コード）：SHA+   上海（都市コード）：SHA
   */
  originLocationCode: string;
}
export namespace CaptchaAuthenticationRequest {
  export type AuthenticationTypeEnum = 'reCAPTCHA' | 'kaptcha';
  export const AuthenticationTypeEnum = {
    ReCaptcha: 'reCAPTCHA' as AuthenticationTypeEnum,
    Kaptcha: 'kaptcha' as AuthenticationTypeEnum,
  };
}
